// =====================================
//
//   觀看樣板規格 Modal
//   Author: Gray
//   createtime: 2016 / 05 / 23
//   updatetime: 2016 / 05 / 23
//
// =====================================

window.InifECApp.directive('templateSpec', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'UserService',
    function($rootScope, $stateParams, $timeout, $ngModal, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('template-spec-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('template-spec-modal');
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_TEMPLATE_SPEC_MODAL", function(event, data) {

                if(data) {
                    $scope.templateName = data.templateName;
                    $scope.orderitem = data.orderitem;
                    openModal();    
                }
            });

                
            /*==========================
                Members
            ==========================*/
            $scope.templateName;
            $scope.orderitem;

            /*==========================
                Methods
            ==========================*/

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/template_spec.html';
        _dir.controller = controller;

        return _dir;
}]);